import React, { FC } from 'react'

import { useEventTimer } from './hooks'

export const EventTimer: FC = () => {
  const { timerTime } = useEventTimer()

  return <>{timerTime}</>
}
